import { render, staticRenderFns } from "./AllMediaPage.vue?vue&type=template&id=4eec1dca&scoped=true"
import script from "./AllMediaPage.vue?vue&type=script&lang=js"
export * from "./AllMediaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec1dca",
  null
  
)

export default component.exports